// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"eca1bb65","952":"9ef5e025"}[chunkId] + ".chunk.js";
};